import { AllValidatosService } from './all.validatos';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostalcodeValidator } from './postalcode.validator';
import { EqualValidator } from './equal.validator';

@NgModule({
  imports: [ CommonModule ],
  declarations: [
    PostalcodeValidator,
    EqualValidator,
  ],
  exports: [
    PostalcodeValidator,
    EqualValidator,
  ],
  providers: [
    AllValidatosService,
  ]
})
export class ValidatorsModule {}



// WEBPACK FOOTER //
// ./src/app/core/component/core/validatos/validatos.module.ts